import { useRulesContext } from "../../../../../hook/useRulesContext";
import BasicSettings from "./FormTabs/BasicSettings";
import ProductsSettings from "./FormTabs/ProductsSettings";
import UsersSettings from "./FormTabs/UsersSettings";

export default function ModalForm() {
    const {
        shortcodeFormData: formData,
        shortcodeModalActiveTab: activeTab,
        loading,
    } = useRulesContext();

    if (loading.singleShortcode) {
        return (
            <div className="h-[calc(90vh-200px)] flex items-center justify-center">
                <div className="animate-pulse space-y-4 w-full p-6">
                    <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
                    <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="h-[calc(90vh-200px)] overflow-y-auto">
            <div className="p-6">
                <div className="space-y-8 mb-6">
                    {activeTab === "basic" && <BasicSettings />}
                    {activeTab === "products" && <ProductsSettings />}
                    {activeTab === "users" && <UsersSettings />}
                </div>
            </div>
        </div>
    );
}
